import { Divider } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AsyncBox } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import ContinueButton from 'components/Atoms/ContinueButton';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Route, useLocation } from 'react-router-dom';
import Eligibility from '../AffordaEligibility';
import PropertyAndProgram from '../AffordaPropertyAndProgram';
import ResultsEligible from '../AffordaResultsEligible';
import ResultsIneligible from '../AffordaResultsIneligible';
import useWelcomePage from './hooks';
import Welcome from './Welcome';

const WelcomePage = ({ url }) => {
  const {
    isFirstPage,
    firstName,
    eligibilityFields,
    isLoading,
    name,
    continueButtonProps,
    ReactHookFormProps,
    onSubmit,
  } = useWelcomePage({ baseURL: url });

  const location = useLocation();
  const isIneligible = React.useMemo(
    () => location.pathname.endsWith('results-ineligible'),
    [location.pathname],
  );

  return (
    <>
      <AsyncBox
        loading={isLoading}
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          textAlign: 'center',
          paddingBottom: 8,
        }}
      >
        <Divider sx={{ width: '100%', marginY: 2 }} />

        <Route
          exact
          path={`${url}/welcome`}
          render={() => <Welcome name={name} />}
        />

        <Route
          exact
          path={`${url}/welcome/property-and-program`}
          render={() => <PropertyAndProgram name={firstName} />}
        />

        <Route
          exact
          path={`${url}/welcome/eligibility`}
          render={() => (
            <Eligibility
              fields={eligibilityFields}
              ReactHookFormProps={ReactHookFormProps}
              onSubmit={onSubmit}
            />
          )}
        />

        <Route
          exact
          path={`${url}/welcome/results-eligible`}
          component={ResultsEligible}
        />

        <Route
          exact
          path={`${url}/welcome/results-ineligible`}
          component={ResultsIneligible}
        />

        <Divider sx={{ width: '100%', marginY: 2 }} />

        <ContinueButton {...continueButtonProps}>
          {isFirstPage ? (
            <FormattedMessage id={'afforda.welcomePage.learnMore'} />
          ) : isIneligible ? (
            <FormattedMessage id={'afforda.resultsIneligible.letsGetStarted'} />
          ) : null}
        </ContinueButton>
      </AsyncBox>
    </>
  );
};

export default WelcomePage;
